import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Confetti from 'react-confetti';
import styles from './PurchaseConfirmation.module.scss';

function PurchaseConfirmation() {
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // update confetti size when window resizes
  React.useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {/* 🎊 Infinite, smooth confetti */}
      <Confetti
        width={windowSize.width}
        height={windowSize.height}
        numberOfPieces={800}
        gravity={0.08} // slower + floaty confetti
        wind={0.01} // slight side drift
        recycle={true} // ♾️ keeps looping forever
        colors={['#ff9800', '#1976d2', '#ffffff', '#ffcc80']}
      />

      <motion.div
        className={styles.imageContainer}
        animate={{
          rotate: [0, 8, -8, 6, -6, 0],
        }}
        transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
      >
        {/* ✅ using image from public folder */}
        <img src="/2-removebg.png" alt="Success" className={styles.successImage} />
      </motion.div>

      <motion.h3
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        Purchase Successful 🎉
      </motion.h3>

      <motion.p
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        Your subscription is now active! Let’s get started.
      </motion.p>

      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.2 }}
      >
        <Button
          className={styles.glowButton}
          variant="contained"
          onClick={() => navigate('/welcome')}
        >
          Start Onboarding 🚀
        </Button>
      </motion.div>
    </motion.div>
  );
}

export default PurchaseConfirmation;
